import styled from "styled-components";
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 80vw;
	height: 80vh;
	background: ${({ theme }) => theme.white};
	padding: 0.4rem;

	@media (max-width: 768px) {
		width: 90vw;
		height: 90vh;
	}
`;
export const ModalContent = styled.div`
	display: flex;
	gap: 2rem;
	flex: 1;
	min-height: 0;
	overflow: hidden;
	margin: 0.4rem 0;

	@media (max-width: 768px) {
		overflow-x: auto;
		overflow-y: hidden;
	}
`;

export const Column = styled.div`
	flex: 0 0 calc(50% - 1rem);
	width: calc(50% - 1rem);
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	min-height: 0;
	overflow: hidden;

	@media (max-width: 768px) {
		flex: 0 0 75vw;
		width: 75vw;
	}
`;

export const ColumnLabel = styled.span`
	font-size: 0.72rem;
	font-weight: 600;
	color: ${({ theme }) => theme.grayDarker};
	text-transform: uppercase;
	letter-spacing: 0.06em;
`;

export const PreviewArea = styled.div<{ $bordered?: boolean }>`
	flex: 1;
	overflow: auto;
	background: #fff;
	padding: 1.25rem;
	font-size: 0.875rem;
	${({ $bordered, theme }) => ($bordered ? `border: 1px solid ${theme.grayDarker}; border-radius: 4px;` : "")}
`;

export const SubjectHeading = styled.div`
	font-size: 1.6rem;
	font-weight: 700;
	color: #1a56db;
	margin-bottom: 1rem;
`;

export const LoadingWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 200px;
`;
